export const EventResultEnum = {
  E_USER_ABORTED: -2,
  E_UNKNOWN_RESULT: -1,
  E_OK: 0,
};

export type EventResult = (typeof EventResultEnum)[keyof typeof EventResultEnum] | number;

export function isEventResultError(code: EventResult | null | undefined) {
  return code != null && code > 0;
}
